import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureNames,
  OperatingProgramCommands,
  OperatingProgramProperties,
  ProgramCommands,
  ProgramProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { HeatingPanelService, HEATING_PROGRAMS } from '../heating-panel.service';

@Component({
  selector: 'app-heating-temperature',
  templateUrl: './heating-temperature.component.html',
  styleUrls: ['./heating-temperature.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingTemperatureComponent implements OnInit {
  @Input() circuitId: string;

  comfort$: Observable<Feature<ProgramProperties, ProgramCommands>>;
  eco$: Observable<Feature<OperatingProgramProperties, OperatingProgramCommands>>;
  comfortHeating$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  reducedHeating$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  normalHeating$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.comfort$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.COMFORT)
    );
    this.eco$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.ECO)
    );
    this.reducedHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitReducedHeating(this.circuitId)
    );
    this.normalHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitNormalHeating(this.circuitId)
    );
    this.comfortHeating$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitComfortHeating(this.circuitId)
    );
  }
}
